import { useContext } from "react";

import { ConfigContext } from "../provider/Config";

const useConfig = () => useContext(ConfigContext);

export default useConfig;
